import { render, staticRenderFns } from "./BindGoods.vue?vue&type=template&id=0d3381c6&scoped=true&"
import script from "./BindGoods.vue?vue&type=script&lang=ts&"
export * from "./BindGoods.vue?vue&type=script&lang=ts&"
import style0 from "./BindGoods.vue?vue&type=style&index=0&id=0d3381c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3381c6",
  null
  
)

export default component.exports